import { request } from './httpClient';

export interface AppMetadata {
  id: number;
  name: string;
  description: string;
  logo?: string;
  homepage_url?: string;
  redirect_uri?: string;
  colour?: string;
  user_count?: number;
  author?: string;
}

export const appsService = {
  list: (params: { limit?: number; page?: number; per_page?: number; search?: string; approved?: '1' }) => {
    const searchParams = new URLSearchParams();
    if (params.limit) searchParams.append('limit', String(params.limit));
    if (params.page) searchParams.append('page', String(params.page));
    if (params.per_page) searchParams.append('per_page', String(params.per_page));
    if (params.search) searchParams.append('search', params.search);
    if (params.approved) searchParams.append('approved', params.approved);
    const query = searchParams.toString();

    return request<{ success: boolean; data: { apps: AppMetadata[]; page: number; per_page: number; total: number; pages: number } }>(
      `/v2/apps/list.php${query ? `?${query}` : ''}`
    );
  }
};
